import React, { useContext } from 'react';

import { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { FieldSettings, SortDescriptor } from 'utils/dataQuery';
import { usePartners } from 'pages/partners/context';
import { Partner } from 'apis/PartnerApi';
import { useIntl } from 'react-intl';

import 'components/PartnerGMetrixTable/partner-gmetrix-table.scss';

interface PartnerGMetrixTableProps<T> {
    advancedSearchFields: FieldSettings[];
    allowExport?: boolean;
    columnData: GMetrixTableColumnProps<Partner>[];
    defaultItemsPerPage?: number;
    getPartnerTypeName?: () => string;
    initialSkip?: number;
    loadingGridData: boolean;
    manualLoadGridData?: boolean;
    multiselect: boolean;
    onDetailsItemClick?: (dataItem: Partner, newPartner?: boolean) => Promise<void>;
    onExportAllData?: () => Promise<Partner[]>;
    onSelectedChange?: (selected: Partner[]) => void;
    onServerPageChange?: (skip: number, take: number) => void;
    onServerSortChange?: (sort: SortDescriptor[]) => void;
    partners: Partner[];
    searchTerm: string;
    selectableRows?: boolean;
    selectedPartners?: Partner[];
    serverSidePagination?: boolean;
    serverTotalCount?: number;
    setSearchTerm: (searchTerm: string) => void;
    toggleColumns?: boolean;
}

export function PartnerGMetrixTable<T>({
    advancedSearchFields,
    allowExport = true,
    columnData,
    defaultItemsPerPage,
    getPartnerTypeName,
    initialSkip,
    loadingGridData,
    multiselect = true,
    onDetailsItemClick,
    onExportAllData,
    onSelectedChange,
    onServerPageChange,
    onServerSortChange,
    partners,
    searchTerm,
    selectableRows = true,
    selectedPartners,
    serverSidePagination = false,
    serverTotalCount,
    setSearchTerm,
    toggleColumns = true
}: PartnerGMetrixTableProps<T>) {

    const { permissions } = usePartners();
    const { formatMessage } = useIntl();

    return (
        <GMetrixTable
            rowData={
                serverSidePagination
                    ? partners.map(partner => {

                        if (!permissions.View) {

                            partner.DisabledDetailsBtn = true;

                        }
                        return partner;

                    })
                    : partners.map(partner => {

                        if (!permissions.View) {

                            partner.DisabledDetailsBtn = true;

                        }
                        return partner;

                    }).filter(partner => (
                        partner.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        partner.UserEmailList.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        partner.Id.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                        partner.CustomerIDString.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                        (partner.ContactEmail &&
                            partner.ContactEmail.toLowerCase().includes(searchTerm.toLowerCase()))
                    ))}
            searchPlaceholder={getPartnerTypeName
                ? formatMessage({ id: 'search_partnertypes_by_name_email_or_cus.730e37d3', defaultMessage: 'Search {partnerType}s by name, email, or customer ID...' }, { partnerType: getPartnerTypeName().toLowerCase() })
                : formatMessage({ id: 'search_partners_by_name_email_or_custome.259d425d', defaultMessage: 'Search partners by name, email, or customer ID...' })}
            allowExport={allowExport}
            bottomBarTableName={getPartnerTypeName && `${getPartnerTypeName()}s`}
            columnData={columnData}
            defaultItemsPerPage={defaultItemsPerPage}
            excelExportFileName={formatMessage({ id: 'partnerlist_type.5c86b745', defaultMessage: 'PartnerList_{type}' }, { type: getPartnerTypeName?.() ?? '' })}
            initialSkip={initialSkip}
            loading={loadingGridData}
            multiSelect={multiselect}
            onDetailsItemClick={onDetailsItemClick}
            onExportAllData={onExportAllData}
            onSelectedChange={onSelectedChange}
            onServerPageChange={serverSidePagination ? onServerPageChange : undefined}
            onServerSortChange={serverSidePagination ? onServerSortChange : undefined}
            searchTerm={searchTerm}
            selectableRows={selectableRows}
            selected={selectedPartners}
            serverSidePagination={serverSidePagination}
            serverTotalCount={serverTotalCount}
            setSearchTerm={setSearchTerm}
            toggleColumns={toggleColumns}
        />
    );

}
